import { cookiePolicy, renderMarkdown } from "@barrykilby/content";
import {
  MANOS_COMPANY_NAME,
  MANOS_PRODUCT_NAME,
  MANOS_SUPPORT_EMAIL,
  MANOS_WEBSITE_URL,
} from "../../config/branding";

const html = renderMarkdown(
  cookiePolicy({
    productName: MANOS_PRODUCT_NAME,
    companyName: MANOS_COMPANY_NAME,
    companyEmail: MANOS_SUPPORT_EMAIL,
    websiteUrl: MANOS_WEBSITE_URL,
  }),
);
export default function Cookies() {
  return (<div className="mx-auto max-w-3xl px-6 py-16"><div className="prose prose-stone dark:prose-invert max-w-none text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: html }} /></div>);
}
